import actions from '../../../../sharedmodules/actions-list';

export const resetUserDealerData = () => ({
    type: actions.RESET_USER_DEALER_MAPPED_DATA,
});
